import React, { Component } from 'react';
import Lightbox from 'lightbox-react';
import styles from './styles.scss';
import _ from 'lodash';
import CONFIG from '../../config';
import http from '../../helpers/http';
import YouTube from 'react-youtube';
import qs from "query-string";
import WJSON from '../../helpers/json';
import WSpinner from '../../components/WSpinner/WSpinner';
import WMask from '../../components/WMask/WMask';
import WFirebase from '../../helpers/firebase';
import UserInfo from '../../helpers/userinfo';

class CasePeriod extends Component 
{
  constructor(props){
    super(props);
    this.state = {
      show_spinner:true,
      no_data: false,
      photoIndex: 0,
      isOpen: false,
      light_imgs: [],
      case_items: [],
      message:null,
      houseid:null,
    };
  }
  componentDidMount(){
    // 將取到的資料設為 state
    // this.setState({case_items: case_data})
    
    this.pullData()

    UserInfo.pullData((code=100, userinfo={}, reason='發生錯誤，請洽社區物管') => {
          this.setState({ houseid: userinfo.houseid });
    })

  }
  pullData(){
    this.setState({ show_spinner: true });

    http.get(
      CONFIG.API_HOST + 'api/v1.3/case/period',
      { }, 
      (state, res) => {
        
        this.setState({ show_spinner: false });
        
        if (state === false) { return this.setState({ message: '發生錯誤' }); }

        if (res.code !== 200) { return this.setState({ message: res.reason }); }

        const { periods }= res.data;

        const case_items = periods || [];

        this.setState({
          // message: case_items.length === 0 && "目前沒有資料",
          no_data: case_items.length === 0,
          case_items: case_items
        },()=>{
          let query = qs.parse(this.props.location.search)

          var show_type =query['show_type']
          console.log('show_type', show_type)
          if (show_type)
          {
            const element = document.querySelector(`div[period-type='${show_type}']`)
            console.log('scroll', element)
            if (element)
            {
              element.scrollIntoView({behavior: 'smooth'});  
            }
          }
        
        })
        
      }
    )
  }
  //判斷影片並轉換資料給LightBox使用
  // transferItems = (selected) => {
  //   let data = _.cloneDeep(selected)
  //   let light_imgs = [];
  //   data.map((data, key)=>{
  //     if (data.type==='video'){

  //       data.pic = (
  //         <video width="100%" height="auto" controls controlsList="nodownload">
  //           <source src={data.video_url} type="video/mp4"/>
  //           Your browser does not support the video tag.
  //         </video>
  //       )
  //     }
  //     let img_item = {
  //       src: data.pic,
  //       name: data.name
  //     }
  //     light_imgs.push(img_item)
  //   });
  //   return light_imgs
  // }
  showLightbox(selected, key){

    let data = _.cloneDeep(selected)
    let light_imgs = [];
    console.log(selected, key)
    
    data.forEach((data, key) => {

      if (data.type == 'video'){
        // <video width="100%" height="auto" controls controlsList="nodownload">
        //   <source src={data.video_url} type="video/mp4"/>
        //   Your browser does not support the video tag.
        // </video>
        data.pic = (
          <YouTube
            videoId={data.youtube_id}
            opts={{
                    height: '100%',
                    width: '100%',
                    playerVars: { // https://developers.google.com/youtube/player_parameters
                      autoplay: 0,
                      showinfo: 0,
                      modestbranding: 1
                    }
                  }}
          />
        )

      }

      let img_item = {
        src: data.pic,
        name: data.name,
        type: data.type
      }

      light_imgs.push(img_item)
    });

    this.setState({ isOpen: true, 
      photoIndex: key,
      light_imgs: light_imgs, 
       })
  }
  closeLightbox = ()=>{

  }
  render()
  { 
    const { photoIndex, isOpen, light_imgs, case_items } = this.state;
    console.log(case_items)
    let lightItem = light_imgs[photoIndex] || null
    
    return (
      <div className={styles.page_container}>
        {isOpen && (
          <Lightbox
            mainSrc={light_imgs[photoIndex].src}
            prevSrc={photoIndex - 1 >= 0 ? light_imgs[(photoIndex + light_imgs.length - 1) % light_imgs.length] : null}
            nextSrc={photoIndex + 1 < light_imgs.length ? light_imgs[(photoIndex + 1) % light_imgs.length] : null}
            imageTitle={light_imgs[photoIndex].name && light_imgs[photoIndex].name}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() => {
              console.log(lightItem)
              if (lightItem.type == 'video')
              {
                console.log('PreVedio')
                WFirebase.logEvent('ConstructionAlbum_PS',{'PreVedio': UserInfo.houseid})
              }
              else
              {
                console.log('PrePic')
                WFirebase.logEvent('ConstructionAlbum_PS',{'PrePic': UserInfo.houseid})
              }

              this.setState({
                photoIndex: (photoIndex + light_imgs.length - 1) % light_imgs.length,
              })
            }}
            enableZoom={false}
            onMoveNextRequest={() => {

              if (lightItem.type == 'video')
              {
                console.log('NextVedio')
                WFirebase.logEvent('ConstructionAlbum_PS',{'NextVedio': UserInfo.houseid})
              }
              else
              {
                console.log('NextPic')
                WFirebase.logEvent('ConstructionAlbum_PS',{'NextPic': UserInfo.houseid})
              }

              this.setState({
                photoIndex: (photoIndex + 1) % light_imgs.length,
              })
            }}
          />
        )}
        {
          case_items.map((item, key)=>{
            // ${img.youtube_id} //require('./imgs/play-btn.jpg')
            return (
              <div id={`period_${item.id}`} period-type={ item.media_type || 'P'} key={key} className={styles.progress_set}>
                <div>
                  <div>
                    <h4>{item.name}</h4>
                    <p>{item.date}</p>
                  </div>
                  {/* <i>{item.pics.length}</i> */}
                </div>
                <div>
                <div className='container-fluid'>
                    <div className="row">
                      { item.pics.map((img, key)=>{
                          return(
                            <div className="col-xs-4 col-sm-3 col-lg-2" key={key}
                              onClick={ () => { 
                                if (img.type == 'video')
                                {
                                  WFirebase.logEvent('ConstructionAlbum_PS',{'Vedio_Album': UserInfo.houseid})
                                }
                                else
                                {
                                  WFirebase.logEvent('ConstructionAlbum_PS',{'Pic_Album': UserInfo.houseid})
                                }
                                this.showLightbox(item.pics, key) 
                              }}
                              >
                              { 
                                img.type == 'video' ?
                                <div className={styles.video}
                                style={{backgroundImage: `url(https://img.youtube.com/vi/${img.youtube_id}/sddefault.jpg), url(${require('./imgs/bg_img.png')})`}}/>
                                :
                                <div className={styles.img}
                                style={{backgroundImage: `url('${img.pic}'), url(${require('./imgs/bg_img.png')})`}}>
                                </div>
                                
                              }
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                </div>
              </div>
            )
          })
        }
        { (this.state.no_data || this.state.message) && 
          <WMask  title={ this.state.message ? this.state.message : ''}>
            { this.state.no_data &&
              <div>
                <h1>目前暫無資料</h1>
              </div>
            }
          </WMask>
        }
        { this.state.show_spinner && <WMask><WSpinner/></WMask> }
      </div>
    );
  }
}

export default CasePeriod;


// WEBPACK FOOTER //
// ./src/views/CasePeriod/CasePeriod.js